import React from 'react';

import { ColumnHeaderSortable } from '../../DataTable/index.jsx';
import { CurrencyFigure } from '../../Figure/index.jsx';

import Column from './base.jsx';


var columnOptions = {
  id: 'g',
  title: 'Floor Price (USD)'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  get rightAlign() {
    return true;
  }
}


var DetailColumn = function(props) {
  return (
    <td className="text-right">
      <CurrencyFigure amount={props.row.floorPrice * props.row.tokenUSD} formatter="medium" zeroIsBlank />
    </td>
  );
}


class FloorPrice extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  sortAscending(a, b) {
    if (a.floorPrice < b.floorPrice) {
      return -1;
    }
    if (a.floorPrice > b.floorPrice) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (a.floorPrice < b.floorPrice) {
      return 1;
    }
    if (a.floorPrice > b.floorPrice) {
      return -1;
    }
    return super.sortDescending(a, b);
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default FloorPrice;

